import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { EPage } from '@types';
import { formatUrl } from '@utils/text';

import { PAGES } from '../constants';

export const useRedirectUrl = (page: EPage): string => {
  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  return formatUrl({
    urlBase: websiteHostAddress,
    path: PAGES[page]?.internal ?? '',
  });
};
